import React, { Component } from "react";
import { Grid, Row, Col } from "react-bootstrap";
import DevicesTable from "./DevicesTable";

// utils
import { get } from "../../../utils/apiService";

// components
// import UsersTable from "./UsersTable";
import DevicesForm from "./DevicesForm";

class Devices extends Component {
  constructor() {
    super();

    this.state = {
      devices: []
    };

    this.handleNewDevice = this.handleNewDevice.bind(this);
  }

  handleNewDevice(device) {
    console.log("device:", device);

    let devices = this.state.devices;
    devices.push(device);

    this.setState({
      devices: devices
    });
  }
  componentDidMount() {
    let url = "/devices";
    get(url).then(res => {
      let devices = res.data;
      this.setState({ devices });
    });
  }
  render() {
    return (
      <Grid>
        <Row>
          <Col md={12}>
            <DevicesForm success={this.handleNewDevice} />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <DevicesTable devices={this.state.devices} />
          </Col>
        </Row>
      </Grid>
    );
  }
}

export default Devices;



// WEBPACK FOOTER //
// ./src/components/pages/Devices/index.js